import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import styled, { css } from "styled-components";
import { FlexRow } from "./common.styles";
export const PillTabsContainer = styled(FlexRow) `
    padding: 8px;
    width: 100%;
    box-sizing: border-box;
`;
export const PillTabsTrack = styled(FlexRow) `
    border: 0.63px solid ${colors.separator_main};
    border-radius: 500px;
    padding: 4px;
    width: 100%;
    position: relative;
    overflow: hidden;
    background-color: ${colors.history_surface_bg};
    align-items: center;
`;
const BasePillTab = css `
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px 0;
    border-radius: 500px;
    font-size: ${fontSizes.SMALL};
    line-height: 21.5px;
    letter-spacing: -0.15px;
    text-align: center;
    white-space: nowrap;
    cursor: pointer;
    border: none;
    outline: none;
    background: transparent;
`;
export const PillTabActive = styled.button `
    ${BasePillTab}
    background: ${colors.white_main};
    border: 0.37px solid rgba(0, 0, 0, 0.12);
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.11), 0px 4px 2px rgba(0, 0, 0, 0.09), 0px 9px 2.5px rgba(0, 0, 0, 0.06),
        0px 15px 3px rgba(0, 0, 0, 0.02);
    font-weight: ${fontWeights.BOLD};
    color: ${colors.navy_light};
`;
export const PillTabInactive = styled.button `
    ${BasePillTab}
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.black_lighter};
    border: 0.37px solid transparent;
`;
